import {createEntityAdapter, createReducer} from '@reduxjs/toolkit';
import addHours from 'date-fns/addHours';
// import cloneDeep from 'lodash/cloneDeep';

import {getQuicksightEmbeddedUrlSuccess,
    getQuicksightEmbeddedUrlFailed, setIdDashboardSelected, getQuicksightEmbeddedUrlRequest, resetDateExpired} from './actions';


const dashboardsAdapter = createEntityAdapter({
    selectId: (dash) => dash.idDash,
    sortComparer: () => 0,
});

const initialState = dashboardsAdapter.getInitialState({
    loading: false,
    selectedDash: '',
});


const dashboardsReducer = createReducer(initialState, {
    [getQuicksightEmbeddedUrlRequest.type]: (state) => {
        state.loading = true;
    },
    [getQuicksightEmbeddedUrlSuccess.type]: (state, action) => {
        state.loading = false;
        state.selectedDash = action.payload.idDash;
        dashboardsAdapter.upsertOne(state, {...action.payload, dateExpired: addHours(new Date(), 10)});
    },
    [getQuicksightEmbeddedUrlFailed.type]: (state) => {
        state.loading = false;
    },
    [setIdDashboardSelected.type]: (state, action) => ({...state, selectedDash: action.payload.idDash}),
    [resetDateExpired.type]: (state) => {
        state.selectedDash=undefined;
        dashboardsAdapter.removeAll(state);
    },

});

export default dashboardsReducer;
